/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from '@material-ui/core/styles';
import {TertiaryButton} from '@ion/dls/src/components/buttons/TertiaryButton';
import {dlsTypography, dlsZIndex} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the prop definitions for the empty identifiers validation ...
export type ImportEmptyIdentifiersValidationDialogProps = {
  title: string;
  message: string;
  actionLabel: string | JSX.Element;
  zIndex?: number;
  onAction: () => void;
};

const useStyles = makeStyles<DLSTheme, ImportEmptyIdentifiersValidationDialogProps>(({dls}) => ({
  identifiersValidationRoot : {
    zIndex : ({zIndex}) => `${zIndex ?? dlsZIndex('userForbiddenDialogRoot')} !important` as any
  },
  title : {
    ...dlsTypography('h4'),
    padding       : '40px 20px 0px 24px',
    lineHeight    : '24px',
    letterSpacing : 1
  },
  content : {
    padding : '0 20px !important'
  },
  actions : {
    justifyContent : 'flex-start',
    padding        : '0px 16px 8px !important',
    marginTop      : -6
  }
}));

/**
 * Modal renders when user attempts to upload empty identifiers.
 */
export const ImportEmptyIdentifiersValidation = (props: ImportEmptyIdentifiersValidationDialogProps) => {
  const {
    title,
    message,
    actionLabel,
    onAction
  } = props;
  const classes    = useStyles(props);
  const messages   = message?.split(';');
  const messageLen = messages?.length;

  return (
    <Dialog open maxWidth={'md'} classes={{
      root : classes.identifiersValidationRoot
    }}>
      <DialogTitle className={classes.title}>
        {title}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText>
          {messages?.map((body, index) => {
            if (index === 0 || index === messageLen-1) {
              return (<p>{body}<br/></p>);
            }
            return (<li>{body}</li>);
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <TertiaryButton style={{padding: 0}} onClick={onAction}>
          {actionLabel}
        </TertiaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default ImportEmptyIdentifiersValidation;
